module.exports = __webpack_public_path__ + "img/AUTO_TRANSPORTS_ACTIVE.f71cee56.svg";